// IE 2026 11 02 / ODOO-349799 (cell-icons) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): иконка в ячейке была ОДНА на колонку — pi
// сегмента ссылки (V.pi, mainStore.get_value_segment). Колонки Kind / Subsystem / Segment / Collection страницы предопределённых записей несут иконку ПО ЗНАЧЕНИЮ:
// бэк (predefined_page.icon_rows) кладёт в строку ключи `<binding>_pi` (kind_pi, addon_pi, segment_pi, collection_pi — класс PrimeIcons, например 'pi pi-book'),
// а колонке — `icon_binding` (имя такого ключа), `icon_level` (kind | addon | segment | collection; нет — выводится из icon_binding) и `icon_method`
// (метод виджета бэка, 'predefined_open_list'). Клик по иконке — executeWidgetMethod(icon_method, {level, value, row_id}) → бэк отвечает штатной командой
// widget_open (список вида / подсистемы / сегмента / коллекции); Alt+клик — прежнее открытие записи (onButtonOpen__Click). У строки-группы wijmo (чип Kind,
// Subsystem) иконка в колонке дерева — по значению группы: класс берётся из первой строки группы (items[0][icon_binding колонки группировки уровня]),
// value — group.name, row_id — нет. Здесь — чистые расчёты без DOM и импортов (tests/unit/gridCellIcons.test.mjs); AttrGrid: formatItem_cells_AttrMulti
// (ячейка строки, оба пути через _cache.linkPi / _cache.linkPiId), groupLevels_cellApply (группа и отступ листа, _cache.grpIcon), диспетчер клика
// (ветка id onCellIcon__Click до ветки cell-link).
// Выключатели (дефолт ВКЛ): fe.ux.gridCellIcons — иконки по значению и клик по ним (выкл — прежняя иконка сегмента, иконки групп нет);
// fe.ux.gridGroupLeafIndent — отступ листовой строки под группой на ширину глифа свёртки (выкл — отступ wijmo как прежде).

export const CELL_ICONS_FLAG = 'fe.ux.gridCellIcons'
export const GROUP_LEAF_INDENT_FLAG = 'fe.ux.gridGroupLeafIndent'
export const CELL_ICON_ID = 'onCellIcon__Click'
export const CELL_ICON_CLASS = 'cell-icon'
export const ICON_LEVELS = ['kind', 'addon', 'segment', 'collection']

export function cellIcons_on(store) {
    try { return store?.setting?.(CELL_ICONS_FLAG, true) !== false } catch (e) { return true }
}

export function groupLeafIndent_on(store) {
    try { return store?.setting?.(GROUP_LEAF_INDENT_FLAG, true) !== false } catch (e) { return true }
}

// Класс иконки — строка вида 'pi pi-book' (буквы, цифры, дефис, подчёркивание, пробелы); иное (объект, html) — ''
export function iconClass_clean(pi) {
    if (pi && typeof pi === 'object') pi = pi.value ?? pi.pi
    if (typeof pi !== 'string') return ''
    const s = pi.trim()
    return /^[\w\- ]+$/.test(s) ? s : ''
}

// Уровень иконки колонки: явный icon_level (из списка ICON_LEVELS) или по icon_binding — 'segment_pi' → 'segment'; иначе ''
export function iconLevel(attr_col) {
    if (!attr_col || typeof attr_col !== 'object') return ''
    const lv = String(attr_col.icon_level || '').trim().toLowerCase()
    if (ICON_LEVELS.includes(lv)) return lv
    const b = String(attr_col.icon_binding || '').trim().toLowerCase()
    const base = b.endsWith('_pi') ? b.slice(0, -3) : b
    return ICON_LEVELS.includes(base) ? base : (base || '')
}

// Класс иконки ячейки строки: колонка с icon_binding, строка — ключ `<binding>_pi`; нет колонки / ключа / значения — ''
export function cellIcon_pi(attr_col, dataItem) {
    if (!attr_col || !attr_col.icon_binding || !dataItem || typeof dataItem !== 'object') return ''
    return iconClass_clean(dataItem[attr_col.icon_binding])
}

// Колонка группировки уровня level: groupDescriptions wijmo (propertyName) → attr_by_binding; лист (level > последнего уровня) — колонка дерева treeAttr
export function groupLevel_attr(attr_by_binding, groupBindings, level, treeAttr) {
    const gb = Array.isArray(groupBindings) ? groupBindings : []
    const lvl = Number.isInteger(level) && level >= 0 ? level : 0
    if (lvl < gb.length) return (attr_by_binding && attr_by_binding[String(gb[lvl])]) || null
    return treeAttr || null
}

// Класс иконки строки-группы: по колонке группировки её уровня, значение — из первой строки группы (группа однородна по полю группировки)
export function groupIcon_pi(attr_col, group) {
    if (!attr_col || !attr_col.icon_binding || !group) return ''
    const items = Array.isArray(group.items) ? group.items : []
    return items.length ? cellIcon_pi(attr_col, items[0]) : ''
}

function esc(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

// Параметры клика: level (уровень колонки), value (значение ячейки — словарь {value} AttrMulti разворачивается), row_id (id строки; у группы — null)
export function cellIcon_params(attr_col, value, dataItem) {
    let v = value
    if (v && typeof v === 'object') v = v.value ?? v.id ?? null
    const row_id = dataItem && typeof dataItem === 'object' ? (dataItem.id ?? dataItem.row_id ?? null) : null
    return { level: iconLevel(attr_col), value: v == null ? null : v, row_id: row_id == null ? null : row_id }
}

export function groupIcon_params(attr_col, group) {
    let v = group ? group.name : null
    if (v && typeof v === 'object') v = v.value ?? v.id ?? null
    return { level: iconLevel(attr_col), value: v == null ? null : v, row_id: null }
}

// Разметка иконки: класс как у иконки ссылки (cell-link — курсор и подсветка), маркер cell-icon, id — ключ ветки клика AttrGrid;
// data-атрибуты — те же параметры клика (читаются из DOM на кэш-пути, где строки/группы под рукой нет)
export function cellIcon_html(pi, params, title) {
    const cls = iconClass_clean(pi)
    if (!cls) return ''
    const p = params || {}
    const a = [`data-level="${esc(p.level ?? '')}"`, `data-value="${esc(p.value ?? '')}"`, `data-row-id="${esc(p.row_id ?? '')}"`]
    const t = title ? ` title="${esc(title)}"` : ''
    return `<i class="cell-link ${CELL_ICON_CLASS} pr-2 ${esc(cls)}" id="${CELL_ICON_ID}" ${a.join(' ')}${t}></i>`
}

// Параметры из data-атрибутов элемента иконки (dataset DOM или словарь {level, value, rowId})
export function cellIcon_paramsFromDataset(ds) {
    const d = ds || {}
    const row = d.rowId ?? d['row-id'] ?? ''
    return { level: String(d.level ?? ''), value: d.value == null || d.value === '' ? null : String(d.value), row_id: row === '' || row == null ? null : String(row) }
}

// Клик по иконке: Alt — открыть запись (прежнее поведение), иначе — метод бэка (нет icon_method — тоже запись)
export function cellIcon_action(attr_col, altKey) {
    const m = attr_col && typeof attr_col.icon_method === 'string' ? attr_col.icon_method.trim() : ''
    return altKey || !m ? { open: true, method: '' } : { open: false, method: m }
}

// Команда для store.executeWidgetMethod
export function cellIcon_command(method, params) {
    return { command: 'executeWidgetMethod', method, params: { level: params.level, value: params.value, row_id: params.row_id } }
}

// Отступ листовой строки под группами: wijmo ставит cellPadLeft + treeIndent × (maxGroupLevel + 1); у группы перед текстом ещё кнопка-глиф свёртки
// шириной glyphW (промер treeLines_frameGlyph: tx — левый край текста после кнопки), у листа её нет — текст листа стоял левее текста родителя.
// IE 2026 11 02 / ODOO-349799 (cell-icons) (живой промер dev02 «Конфігурація» 02.11: treeIndent 14, tx 20 — текст листа с + glyphW стоял на 5px левее текста группы):
// текст листа — ПРАВЕЕ текста родительской группы (уровень maxGroupLevel) на ширину glyphW, как лист под раскрытым узлом дерева: отступ = cellPadLeft +
// treeIndent × maxGroupLevel + 2 × glyphW (кнопка родителя + ещё одна ширина). iconDelta — разница ширин иконок значения родителя и листа (есть у родителя,
// нет у листа — +, наоборот — −), чтобы сравнивались ТЕКСТЫ, а не левые края иконок. glyphW не промерен (0, экспорт) — отступ wijmo как прежде.
// Глубина группировки < 0 (нет групп) — null (не трогать)
export function leafPad(cellPadLeft, treeIndent, maxGroupLevel, glyphW, iconDelta = 0) {
    const lvl = Number.isInteger(maxGroupLevel) ? maxGroupLevel : -1
    if (lvl < 0) return null
    const g = Number(glyphW) || 0
    if (g <= 0) return null
    const p = Number(cellPadLeft) || 0, t = Number(treeIndent) || 0
    return Math.max(0, p + t * lvl + 2 * g + (Number(iconDelta) || 0))
}
